import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DnaProfileService } from '@app/shared/services/dna-profile.service';
import {
  loadCandidateDna,
  loadCandidateDnaApplications,
  loadCandidateDnaApplicationsError,
  loadCandidateDnaApplicationsSuccess,
  loadCandidateDnaError,
  loadCandidateDnaSuccess,
} from './candidate-dna.actions';
import { DnaJobApplicationsService } from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/services/dna-job-applications.service';
import { DnaProfileMockService } from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/services/dna-profile-mock.service';

// Set to false to fetch real data from the BE candidate-dna endpoint.
export const USE_DNA_MOCK = true;

@Injectable()
export class CandidateDnaEffects {
  private actions$ = inject(Actions);
  private dnaProfileService = inject(DnaProfileService);
  private dnaJobApplicationsService = inject(DnaJobApplicationsService);
  private dnaProfileMockService = inject(DnaProfileMockService);

  loadCandidateDna$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCandidateDna),
      switchMap(({ id }) =>
        this.dnaProfileService.getCandidateDna(id).pipe(
          map((dna) => loadCandidateDnaSuccess({ dna })),
          catchError((error) => of(loadCandidateDnaError({ error }))),
        ),
      ),
    ),
  );

  loadCandidateDnaApplications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCandidateDnaApplications),
      switchMap(() => {
        const applications$ = USE_DNA_MOCK
          ? this.dnaProfileMockService.getApplications()
          : this.dnaJobApplicationsService.getApplications();
        return applications$.pipe(
          map((applications) => loadCandidateDnaApplicationsSuccess({ applications })),
          catchError((error) => of(loadCandidateDnaApplicationsError({ error }))),
        );
      }),
    ),
  );
}
